import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["step1", "step2", "competencesList", "stepper"];

  connect() {
    // Ensure only step 1 is visible on load
    this.showStep(1);
  }

  nextStep(event) {
    event.preventDefault();
    this.showStep(2);
  }

  prevStep(event) {
    event.preventDefault();
    this.showStep(1);
  }

  showStep(step) {
    if (step === 1) {
      this.step1Target.style.display = "";
      this.step2Target.style.display = "none";
    } else {
      this.step1Target.style.display = "none";
      this.step2Target.style.display = "";
    }
  }

  addCompetence(event) {
    event.preventDefault();
    const competencesList = this.competencesListTarget;
    const idx = competencesList.querySelectorAll(
      "[data-competence-index]"
    ).length;
    const template = document.createElement("div");
    template.className = "flex items-center gap-2 mb-2";
    template.setAttribute("data-competence-index", idx);
    template.innerHTML = `
      <input type="text" name="evaluation[competences][][name]" placeholder="Nom de la compétence" class="flex-1 rounded border px-2 py-1" />
      <input type="number" name="evaluation[competences][][scale]" min="1" placeholder="Pts" class="w-24 rounded border px-2 py-1" />
      <button type="button" class="text-red-600 px-2" data-action="evaluation-type#removeCompetence" data-index="${idx}">✕</button>
    `;
    competencesList.appendChild(template);
  }

  removeCompetence(event) {
    event.preventDefault();
    const idx = event.currentTarget.getAttribute("data-index");
    const row = this.competencesListTarget.querySelector(
      `[data-competence-index='${idx}']`
    );
    if (row) row.remove();
    this.renumberCompetences();
  }

  renumberCompetences() {
    // Re-index all competence rows and update their input names
    const rows = this.competencesListTarget.querySelectorAll(
      "[data-competence-index]"
    );
    rows.forEach((row, newIdx) => {
      row.setAttribute("data-competence-index", newIdx);
      const nameInput = row.querySelector('input[type="text"]');
      const scaleInput = row.querySelector('input[type="number"]');
      const removeBtn = row.querySelector(
        'button[data-action="evaluation-type#removeCompetence"]'
      );
      if (nameInput)
        nameInput.name = `evaluation[competences_attributes][${newIdx}][name]`;
      if (scaleInput)
        scaleInput.name = `evaluation[competences_attributes][${newIdx}][scale]`;
      if (removeBtn) removeBtn.setAttribute("data-index", newIdx);
    });
  }

  hideAllFields() {
    [
      this.sequenceFieldTarget,
      this.trimesterFieldTarget,
      this.monthFieldTarget,
    ].forEach((field) => this.hideField(field));
  }

  hideField(field) {
    field.style.display = "none";
    // Désactiver les champs à l'intérieur
    field.querySelectorAll("input, select").forEach((input) => {
      input.disabled = true;
    });
  }

  showField(field) {
    field.style.display = "";
    // Réactiver les champs à l'intérieur
    field.querySelectorAll("input, select").forEach((input) => {
      input.disabled = false;
    });
  }

  // Gestion des étudiants lors du changement d'évaluation
  // async loadStudents(event) {
  //   if (!this.hasEvaluationSelectTarget || !this.hasStudentSelectTarget) return;

  //   const evaluationId = this.evaluationSelectTarget.value;
  //   this.studentSelectTarget.disabled = true;

  //   if (!evaluationId) {
  //     this.resetStudentSelect();
  //     return;
  //   }

  //   try {
  //     const response = await fetch(`/schools/grades/students?evaluation_id=${evaluationId}`);
  //     if (!response.ok) throw new Error('Erreur lors du chargement des étudiants');

  //     const students = await response.json();
  //     this.updateStudentSelect(students);
  //   } catch (error) {
  //     console.error('Erreur:', error);
  //     this.resetStudentSelect();
  //   }
  // }

  updateStudentSelect(students) {
    if (!this.hasStudentSelectTarget) return;

    const select = this.studentSelectTarget;
    select.innerHTML = '<option value="">Sélectionnez un élève</option>';

    students.forEach((student) => {
      const option = new Option(student.full_name, student.id);
      select.add(option);
    });

    select.disabled = false;
  }

  resetStudentSelect() {
    if (!this.hasStudentSelectTarget) return;

    const select = this.studentSelectTarget;
    select.innerHTML =
      '<option value="">Sélectionnez d\'abord une évaluation</option>';
    select.disabled = true;
  }

  toggleAbsent(event) {
    if (!this.hasScoreInputTarget) return;

    const isAbsent = event.target.checked;
    this.scoreInputTarget.disabled = isAbsent;
    if (isAbsent) {
      this.scoreInputTarget.value = "";
    }
  }

  validate(event) {
    const score = parseFloat(this.scoreInputTarget?.value);
    if (score < 0 || score > 20) {
      event.preventDefault();
      alert("La note doit être comprise entre 0 et 20");
    }
  }
}
